/**
 * @prettier
 */

/**
 *
 * @param {LocationsWS} locationService
 */
function ResourceSelectionViewModel(locationsWs) {
  this.locationsWS = locationsWs;

  return this;
}

ResourceSelectionViewModel.prototype = Object.create({});

/**
 *
 * @param {Array} prevLocations
 * @param {Array} locations.
 * @return {} an object describing the Resources to toggle on or off.
 */
ResourceSelectionViewModel.prototype.toggleResourcesDescriptor = function (prevLocations, locations) {
  var result = {};

  var locationsAdded = locations.filter(function (location) {
    return prevLocations.indexOf(location) == -1;
  });

  result.toSelect = locationsAdded
    .map(
      function (id) {
        return this.locationsWS.indexedLocations()[parseInt(id, 0)];
      }.bind(this)
    )
    .filter(function (l) {
      // Only process existing Locations
      return l;
    })
    .reduce(function (resourceIds, locationModel) {
      return resourceIds.concat(locationModel.resourceIds());
    }, []);

  result.locationsAdded = locationsAdded;

  var locationsRemoved = prevLocations.filter(function (location) {
    return locations.indexOf(location) == -1;
  });

  result.toDeselect = locationsRemoved
    .map(
      function (id) {
        return this.locationsWS.indexedLocations()[parseInt(id, 0)];
      }.bind(this)
    )
    .filter(function (l) {
      // Only process existing Locations
      return l;
    })
    .reduce(function (resourceIds, locationModel) {
      return resourceIds.concat(locationModel.resourceIds());
    }, []);

  result.locationsRemoved = locationsRemoved;

  return result;
};

if (typeof exports !== "undefined") {
  exports.ResourceSelectionViewModel = ResourceSelectionViewModel;
}
